import type {DragEvent} from 'react';
import {AwCard, AwCheckbox, AwEnvironmentDot, AwPriorityPill, AwSelect} from '@ascension-tracker/ascension-ui';
import {TagChips} from './TagChips.js';
import type {Task} from '../hooks/useTasks.js';

function formatDue(value: string | null) {
  if (!value) return null;
  return new Date(value).toLocaleDateString(undefined, {month: 'short', day: 'numeric'});
}

export function TaskCard({task, columns, onToggle, onOpen, onMoveTo, onDragStart, onDragEnd, onCardDragOver, onCardDrop}: {
  task: Task;
  columns: Array<{id: string | null; name: string}>;
  onToggle: () => void;
  onOpen: () => void;
  onMoveTo: (sectionId: string | null) => void;
  onDragStart: () => void;
  onDragEnd: () => void;
  onCardDragOver: (event: DragEvent) => void;
  onCardDrop: (event: DragEvent) => void;
}) {
  const due = formatDue(task.dueOn);
  return (
    <AwCard
      className={`task-card${task.completedAt ? ' is-complete' : ''}`}
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragOver={onCardDragOver}
      onDrop={onCardDrop}
    >
      <header className="task-card__header">
        <AwCheckbox id={`board-task-complete-${task.id}`} label="" checked={Boolean(task.completedAt)} onChange={onToggle}/>
        <button type="button" className="task-card__title" onClick={onOpen}>{task.title}</button>
      </header>
      <TagChips tags={task.tags}/>
      <div className="task-card__badges">
        <AwPriorityPill priority={task.priority}/>
        <AwEnvironmentDot environment={task.environment}/>
        {task.releaseVersion && <span className="task-card__release">{task.releaseVersion}</span>}
      </div>
      <footer className="task-card__footer">
        {task.assigneeName && <span>{task.assigneeName}</span>}
        {due && <span>{due}</span>}
      </footer>
      <AwSelect id={`board-move-${task.id}`} label="Move to" value={task.sectionId ?? ''} onChange={event => onMoveTo(event.target.value || null)}>
        {columns.map(column => <option key={column.id ?? 'none'} value={column.id ?? ''}>{column.name}</option>)}
      </AwSelect>
    </AwCard>
  );
}
